import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    ac_unit: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22 11h-4.17l3.24-3.24-1.41-1.42L15.83 10H13V7.17l3.24-3.24-1.42-1.41L11 6.34V2h-2v4.34L5.18 2.52 3.76 3.94 7 7.17V10H4.17L.93 6.76 2.35 5.34 6.17 9.24 2.93 6l1.42 1.41L7.17 10H10v2.83l-3.24 3.24 1.41 1.42L11 13.66V18h2v-4.34l3.82 3.82 1.42-1.41L15 12.83V10h2.83l3.24 3.24 1.41-1.42L19.24 8.76 22 11z"/>
      </svg>
    ),
    wb_sunny: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/>
      </svg>
    ),
    eco: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M15.5 5H11l1.5-2h2zM23 12.5c0-2.5-1.54-4.96-4-5.74V5.5c0-.83-.67-1.5-1.5-1.5h-11C5.67 4 5 4.67 5 5.5v1.26C2.54 7.54 1 10 1 12.5S2.54 17.46 5 18.24V19.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1.26c2.46-.78 4-3.24 4-5.74zM7.5 7.03c2.73 0 4.97 2.21 4.97 4.97s-2.24 4.97-4.97 4.97S2.53 14.73 2.53 12s2.21-4.97 4.97-4.97z"/>
      </svg>
    ),
    nature: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M13,16.12C16.06,15.71 18.5,13.1 18.5,10C18.5,6.58 15.92,3.79 12.5,3.79C9.08,3.79 6.5,6.58 6.5,10C6.5,13.1 8.94,15.71 12,16.12V19H8V21H16V19H13V16.12ZM12.5,5.79C14.81,5.79 16.5,7.69 16.5,10S14.81,14.21 12.5,14.21S8.5,12.31 8.5,10S10.19,5.79 12.5,5.79Z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    trending_down: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    smart_toy: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm2-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    grass: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L16.25,14.1L15.5,15.5L11,13V7H12.5Z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const SeasonalBusinessPhoneCoverage = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const seasonalBusinesses = [
    {
      name: "Landscaping & Lawn Care",
      icon: "grass",
      peakSeason: "Spring/Summer",
      slowSeason: "Fall/Winter",
      peakMonths: "March - September",
      challenges: [
        "85% of revenue in 6 months",
        "Weather-dependent scheduling",
        "High call volume during peak times",
        "Need to book for following season"
      ]
    },
    {
      name: "Pool Services",
      icon: "wb_sunny",
      peakSeason: "Summer",
      slowSeason: "Winter",
      peakMonths: "May - September",
      challenges: [
        "90% of calls in summer months",
        "Emergency pool repairs",
        "Seasonal opening/closing rush",
        "Maintenance scheduling conflicts"
      ]
    },
    {
      name: "HVAC Services",
      icon: "ac_unit",
      peakSeason: "Summer/Winter",
      slowSeason: "Spring/Fall",
      peakMonths: "June-Aug, Dec-Feb",
      challenges: [
        "Emergency calls during extreme weather",
        "Seasonal maintenance surges",
        "Staff overwhelmed during peaks",
        "Customer wait times increase"
      ]
    },
    {
      name: "Tree Services",
      icon: "nature",
      peakSeason: "Fall/Spring",
      slowSeason: "Winter",
      peakMonths: "March-May, Sept-Nov",
      challenges: [
        "Storm damage emergencies",
        "Dormant season limitations",
        "Weather-dependent scheduling",
        "Seasonal cleanup requests"
      ]
    }
  ];

  const seasonalChallenges = [
    {
      challenge: "Peak Season Overwhelm",
      description: "Call volume can increase 300-500% during peak months",
      impact: "Missed calls = lost revenue during most profitable time",
      icon: "trending_up"
    },
    {
      challenge: "Slow Season Waste", 
      description: "Pay for full reception staff even when call volume drops 80%",
      impact: "Fixed costs eat into already reduced seasonal profits",
      icon: "trending_down"
    },
    {
      challenge: "Booking for Next Season",
      description: "Need to capture early bookings during current season",
      impact: "Poor phone coverage loses advance bookings worth thousands",
      icon: "schedule"
    },
    {
      challenge: "Emergency Call Handling",
      description: "Weather events create sudden spikes in urgent calls",
      impact: "Reputation damaged when customers can't reach you",
      icon: "warning"
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Seasonal Business Phone Coverage - AI Receptionist for Seasonal Industries",
    "description": "Perfect phone coverage solution for seasonal businesses. Scale up/down with demand while never missing calls during peak seasons.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="Seasonal Business Phone Coverage - AI Receptionist for Seasonal Industries"
        description="Perfect phone solution for seasonal businesses like landscaping, pool services, and HVAC. Scale with demand, never miss peak season calls."
        keywords="seasonal business phone coverage, landscaping phone service, pool service phone answering, hvac phone system, seasonal ai receptionist"
        canonical="https://receptioneer.ai/seasonal-business-phone-coverage"
        ogTitle="Seasonal Business Phone Coverage - Scale with Your Seasons"
        ogDescription="AI phone coverage that adapts to seasonal demand. Never miss calls during peak season, no wasted costs during slow periods."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-green-900 via-green-800 to-emerald-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              Seasonal Business
              <br />
              <span className="text-green-200">Phone Coverage</span>
            </h1>
            
            <p className="text-xl text-green-100 mb-12 leading-relaxed max-w-3xl mx-auto">
              The perfect phone solution for businesses with seasonal demand. Scale with your busy periods, never miss peak season calls, and avoid paying for unused capacity.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="bg-white text-green-900 hover:bg-green-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Seasonal Coverage →
              </button>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-green-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test Seasonal AI
              </a>
            </div>

            <div className="bg-white/10 rounded-2xl p-6 max-w-2xl mx-auto">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-black text-white">Peak</div>
                  <div className="text-green-200 text-sm">Season Ready</div>
                </div>
                <div>
                  <div className="text-2xl font-black text-white">Smart</div>
                  <div className="text-green-200 text-sm">Scaling</div>
                </div>
                <div>
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-green-200 text-sm">Year-Round</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Seasonal Business Types */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Perfect for <span className="text-green-600">Seasonal Businesses</span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              {seasonalBusinesses.map((business, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-lg">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name={business.icon} className="w-8 h-8 text-green-600" />
                    <div>
                      <h3 className="text-xl font-black text-gray-900">{business.name}</h3>
                      <div className="text-sm text-gray-600">Peak: {business.peakMonths}</div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="bg-green-50 rounded-xl p-4">
                      <div className="font-bold text-green-800 text-sm mb-1">Peak Season</div>
                      <div className="text-green-600">{business.peakSeason}</div>
                    </div>
                    <div className="bg-gray-100 rounded-xl p-4">
                      <div className="font-bold text-gray-800 text-sm mb-1">Slow Season</div>
                      <div className="text-gray-600">{business.slowSeason}</div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="font-bold text-gray-900 mb-3">Seasonal Challenges:</div>
                    <ul className="space-y-2">
                      {business.challenges.map((challenge, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <MaterialIcon name="warning" className="w-4 h-4 text-orange-500 flex-shrink-0 mt-1" />
                          <span className="text-gray-700 text-sm">{challenge}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Seasonal Challenges */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Seasonal Business <span className="text-red-600">Challenges</span>
            </h2>
            
            <div className="space-y-6">
              {seasonalChallenges.map((item, index) => (
                <div key={index} className="bg-red-50 border-2 border-red-200 rounded-3xl p-8">
                  <div className="flex items-start gap-6">
                    <MaterialIcon name={item.icon} className="w-12 h-12 text-red-600 flex-shrink-0" />
                    <div className="flex-1">
                      <h3 className="text-xl font-black text-red-900 mb-3">{item.challenge}</h3>
                      <p className="text-red-800 mb-3">{item.description}</p>
                      <div className="bg-red-100 rounded-xl p-4">
                        <div className="font-bold text-red-800 text-sm mb-1">Business Impact:</div>
                        <div className="text-red-700">{item.impact}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* AI Solution */}
        <section className="py-16 px-6 bg-blue-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              AI <span className="text-blue-900">Seasonal Solution</span>
            </h2>
            
            <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
              <div className="flex items-center gap-3 mb-6">
                <MaterialIcon name="smart_toy" className="w-8 h-8 text-blue-600" />
                <h3 className="text-2xl font-black text-gray-900">Perfect for Seasonal Businesses</h3>
              </div>
              
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-black text-blue-900 mb-4">Peak Season Benefits:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Handle unlimited call volume</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Never miss high-value peak calls</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Book appointments for next season</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Instant emergency call routing</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-black text-blue-900 mb-4">Off-Season Benefits:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Same low cost year-round</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Capture early season bookings</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Maintenance & consultation calls</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <span className="text-gray-700">Professional image maintained</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-green-50 border-2 border-green-200 rounded-3xl p-8">
                <h3 className="text-xl font-black text-green-900 mb-4">Peak Season Scenario</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-green-800">March call volume:</span>
                    <span className="font-bold text-green-600">500 calls</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-green-800">Traditional reception cost:</span>
                    <span className="font-bold text-red-600">$2,500+</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-green-800">AI reception cost:</span>
                    <span className="font-bold text-green-600">$399</span>
                  </div>
                  <div className="bg-green-100 rounded-xl p-4">
                    <div className="font-bold text-green-800">Peak Season Savings: $2,100+</div>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border-2 border-blue-200 rounded-3xl p-8">
                <h3 className="text-xl font-black text-blue-900 mb-4">Off-Season Scenario</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-blue-800">December call volume:</span>
                    <span className="font-bold text-blue-600">50 calls</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-blue-800">Traditional reception cost:</span>
                    <span className="font-bold text-red-600">$1,500+ (waste)</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-blue-800">AI reception cost:</span>
                    <span className="font-bold text-green-600">$399</span>
                  </div>
                  <div className="bg-blue-100 rounded-xl p-4">
                    <div className="font-bold text-blue-800">Off-Season Savings: $1,100+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industry Examples */}
        <section className="py-16 px-6 bg-gray-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Real Seasonal <span className="text-green-600">Examples</span>
            </h2>
            
            <div className="space-y-8">
              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="grass" className="w-8 h-8 text-green-600" />
                  <h3 className="text-xl font-black text-gray-900">Green Valley Landscaping</h3>
                </div>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-green-50 rounded-xl p-6">
                    <div className="font-bold text-green-800 mb-2">Peak Season (Apr-Oct)</div>
                    <ul className="text-sm text-green-700 space-y-1">
                      <li>• 400+ calls/month</li>
                      <li>• Emergency tree removal</li>
                      <li>• Weekly maintenance bookings</li>
                      <li>• Next season pre-bookings</li>
                    </ul>
                  </div>
                  
                  <div className="bg-blue-50 rounded-xl p-6">
                    <div className="font-bold text-blue-800 mb-2">Slow Season (Nov-Mar)</div>
                    <ul className="text-sm text-blue-700 space-y-1">
                      <li>• 80+ calls/month</li>
                      <li>• Snow removal requests</li>
                      <li>• Spring service planning</li>
                      <li>• Equipment maintenance</li>
                    </ul>
                  </div>
                  
                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="font-bold text-gray-800 mb-2">AI Benefits</div>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• $18k annual savings</li>
                      <li>• 100% call coverage</li>
                      <li>• Emergency dispatch</li>
                      <li>• Consistent service</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-3xl p-8 shadow-lg">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="wb_sunny" className="w-8 h-8 text-orange-500" />
                  <h3 className="text-xl font-black text-gray-900">Crystal Clear Pool Services</h3>
                </div>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-orange-50 rounded-xl p-6">
                    <div className="font-bold text-orange-800 mb-2">Summer Peak (May-Sep)</div>
                    <ul className="text-sm text-orange-700 space-y-1">
                      <li>• 600+ calls/month</li>
                      <li>• Pool opening rush</li>
                      <li>• Emergency repairs</li>
                      <li>• Weekly cleaning schedules</li>
                    </ul>
                  </div>
                  
                  <div className="bg-blue-50 rounded-xl p-6">
                    <div className="font-bold text-blue-800 mb-2">Winter Slow (Oct-Apr)</div>
                    <ul className="text-sm text-blue-700 space-y-1">
                      <li>• 40+ calls/month</li>
                      <li>• Pool closing services</li>
                      <li>• Winter maintenance</li>
                      <li>• Next season bookings</li>
                    </ul>
                  </div>
                  
                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="font-bold text-gray-800 mb-2">AI Benefits</div>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• $24k annual savings</li>
                      <li>• Peak season coverage</li>
                      <li>• Emergency handling</li>
                      <li>• Year-round booking</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-6 bg-green-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Perfect for Your Seasonal Business
            </h2>
            
            <p className="text-xl text-green-100 mb-12">
              One solution that scales with your seasons. Never miss peak calls, never overpay during slow periods.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="grid md:grid-cols-3 gap-6 text-center mb-8">
                <div>
                  <div className="text-3xl font-black mb-2">$399</div>
                  <div className="text-green-200">per month, year-round</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">24/7</div>
                  <div className="text-green-200">peak season ready</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">$20k+</div>
                  <div className="text-green-200">annual savings</div>
                </div>
              </div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-green-900 hover:bg-green-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Seasonal Coverage →
              </button>
            </div>
            
            <p className="text-green-200">Ready in 24 hours • Cancel anytime • Perfect for seasonal businesses</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Seasonal Coverage"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set for every season!</h3>
              <p className="text-gray-600">Your seasonal AI receptionist will be ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Sarah Johnson"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="sarah@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Coverage...' : 'Get Seasonal AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/seasonal-business-phone-coverage" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default SeasonalBusinessPhoneCoverage;